// Generated by web/scripts/job-types-index.mjs from contracts/openapi.json. Never edit by hand.
import type { JobTypeModules } from "./contract";
import { jobType as audio_extract } from "./audio_extract";
import { jobType as audio_music } from "./audio_music";
import { jobType as audio_sfx } from "./audio_sfx";
import { jobType as audio_tts } from "./audio_tts";
import { jobType as audio_voiceover } from "./audio_voiceover";
import { jobType as caption_transcribe } from "./caption_transcribe";
import { jobType as extract_brand } from "./extract_brand";
import { jobType as extract_product } from "./extract_product";
import { jobType as image_actor } from "./image_actor";
import { jobType as image_advanced } from "./image_advanced";
import { jobType as image_analysis } from "./image_analysis";
import { jobType as image_layer_edit } from "./image_layer_edit";
import { jobType as image_layerize } from "./image_layerize";
import { jobType as image_simple } from "./image_simple";
import { jobType as image_template } from "./image_template";
import { jobType as image_tweak } from "./image_tweak";
import { jobType as text_actor_description } from "./text_actor_description";
import { jobType as text_ad_copy } from "./text_ad_copy";
import { jobType as text_enhance } from "./text_enhance";
import { jobType as text_generate } from "./text_generate";
import { jobType as text_script } from "./text_script";
import { jobType as text_shot_list } from "./text_shot_list";
import { jobType as video_audio } from "./video_audio";
import { jobType as video_background } from "./video_background";
import { jobType as video_caption } from "./video_caption";
import { jobType as video_dub } from "./video_dub";
import { jobType as video_edit } from "./video_edit";
import { jobType as video_extend } from "./video_extend";
import { jobType as video_frames } from "./video_frames";
import { jobType as video_image } from "./video_image";
import { jobType as video_lipsync } from "./video_lipsync";
import { jobType as video_merge } from "./video_merge";
import { jobType as video_motion } from "./video_motion";
import { jobType as video_overlay } from "./video_overlay";
import { jobType as video_pixel_snap } from "./video_pixel_snap";
import { jobType as video_reference } from "./video_reference";
import { jobType as video_reframe } from "./video_reframe";
import { jobType as video_shots } from "./video_shots";
import { jobType as video_splice } from "./video_splice";
import { jobType as video_talking_head } from "./video_talking_head";
import { jobType as video_talking_head_advanced } from "./video_talking_head_advanced";
import { jobType as video_template } from "./video_template";
import { jobType as video_text } from "./video_text";
import { jobType as video_upscale } from "./video_upscale";
import { jobType as video_voice_swap } from "./video_voice_swap";
import { jobType as voice_clone } from "./voice_clone";
import { jobType as voice_design } from "./voice_design";
import { jobType as voice_profile } from "./voice_profile";

/** Every job type's module, by its id (spec F9). */
export const JOB_TYPES: JobTypeModules = {
  "audio.extract": audio_extract,
  "audio.music": audio_music,
  "audio.sfx": audio_sfx,
  "audio.tts": audio_tts,
  "audio.voiceover": audio_voiceover,
  "caption.transcribe": caption_transcribe,
  "extract.brand": extract_brand,
  "extract.product": extract_product,
  "image.actor": image_actor,
  "image.advanced": image_advanced,
  "image.analysis": image_analysis,
  "image.layer_edit": image_layer_edit,
  "image.layerize": image_layerize,
  "image.simple": image_simple,
  "image.template": image_template,
  "image.tweak": image_tweak,
  "text.actor_description": text_actor_description,
  "text.ad_copy": text_ad_copy,
  "text.enhance": text_enhance,
  "text.generate": text_generate,
  "text.script": text_script,
  "text.shot_list": text_shot_list,
  "video.audio": video_audio,
  "video.background": video_background,
  "video.caption": video_caption,
  "video.dub": video_dub,
  "video.edit": video_edit,
  "video.extend": video_extend,
  "video.frames": video_frames,
  "video.image": video_image,
  "video.lipsync": video_lipsync,
  "video.merge": video_merge,
  "video.motion": video_motion,
  "video.overlay": video_overlay,
  "video.pixel_snap": video_pixel_snap,
  "video.reference": video_reference,
  "video.reframe": video_reframe,
  "video.shots": video_shots,
  "video.splice": video_splice,
  "video.talking_head": video_talking_head,
  "video.talking_head_advanced": video_talking_head_advanced,
  "video.template": video_template,
  "video.text": video_text,
  "video.upscale": video_upscale,
  "video.voice_swap": video_voice_swap,
  "voice.clone": voice_clone,
  "voice.design": voice_design,
  "voice.profile": voice_profile,
};
